<div class="d-flex flex-column">
  <div class="d-flex flex-column flex-sm-row justify-content-between text-body-lg mb-24">
    <span [innerHtml]="autopayPromotionDetails.modalBody | translate"></span>
  </div>

  @if (totalAutopayPromotions > 0) {
    @for (promo of autopayPromotionDetails.promotions; track promo; let isLastDiscountType = $last) {
      <div class="d-flex flex-sm-row flex-column">
        <span>
          {{
            autopayPromotionDetails.discountMessage
              | translate: { discountValue: promo.value | formatDiscount: promo.UOM : language }
          }}
          &nbsp;
        </span>
        @if (autopayPromotionDetails.isEnroll && !!promo.expirationDate) {
          <span>
            {{
              'overview.autopay-promo.details.eligible-until'
                | translate: { expiryDate: promo.expirationDate | date: dateFormat : '' : language }
            }}
          </span>
        }
      </div>
      @for (subscriber of promo.subscribers; track subscriber; let isLastSubscriber = $last) {
        <div class="d-flex flex-row mt-16" [class.mb-32]="isLastSubscriber && !isLastDiscountType">
          <ds-icon [name]="'wireless'"></ds-icon>
          <div class="d-flex flex-sm-row flex-column ml-12">
            <span class="text-bold mr-12 mb-12">{{ subscriber.name }}</span>
            <span class="mr-12 mb-12">{{ subscriber.subNumber | formatPhone }}</span>
          </div>
        </div>
      }
    }
  }
</div>
